import { render } from "./Datalists.vue?vue&type=template&id=4ecd39f5"
import script from "./Datalists.vue?vue&type=script&lang=js"
export * from "./Datalists.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__